import * as DTOS from "../FeralScan.dtos";

export interface IUserRegister {
    agreedTerms: boolean;
    email: string;
    fullName: string;
    surname: string;
    mobileNumber: string;
    password: string;
    passwordConfirm: string;
    postcode: string;

    // product fields
    platypusSeen?: string;
}

export interface IUserUpdate {
    email: string;
    fullName: string;
    surname: string;
    mobileNumber: string;
    postcode: string;
}

export interface IBaseUserActions {
    type: string;
}

export interface IChangePasswordRequestAction extends IBaseUserActions {
    newPassword: string;
}

export interface IChangePasswordSuccessAction extends IBaseUserActions {
    user: DTOS.User;
}

export interface IAssignUserRoleRequestAction extends IBaseUserActions {
    userId: number;
    roleId: number;
    plotId?: number;
}

export interface IAssignUserRoleSuccessAction extends IBaseUserActions {
    newUserRole: DTOS.UserRole;
}

export interface IAssignUserRoleFailureAction extends IBaseUserActions {
}

export interface IUnassignUserRoleRequestAction extends IBaseUserActions {
    userRoleId: number;
}

export interface IUnassignUserRoleSuccessAction extends IBaseUserActions {
}

export interface IUnassignUserRoleFailureAction extends IBaseUserActions {
}

export interface IUpdateUserPreferencesRequestAction extends IBaseUserActions {
    preferences: any;
}

export interface IUpdateUserPreferencesSuccessAction extends IBaseUserActions {
}

export interface IRegisterUserRequestAction extends IBaseUserActions {
    user: IUserRegister;
}

export interface IRegisterUserSuccessAction extends IBaseUserActions {
}

export interface IUpdateUserRequestAction extends IBaseUserActions {
    user: IUserUpdate;
}

export interface IUpdateUserSuccessAction extends IBaseUserActions {
    user: DTOS.User;
}

export interface IUpdateUserFailureAction extends IBaseUserActions {
}

export interface IEmailOptOutRequest extends IBaseUserActions {
    optOutStatus: boolean;
}

export interface IEmailOptOutSuccess extends IBaseUserActions {
}

export interface IEmailOptOutFailure extends IBaseUserActions {
}

export interface IUserActions {
    type: string,

    //getCurrentUserRequestSuccess
    currentUser?: DTOS.User,

    //registeruser, registerusersuccess
    user?: DTOS.User,

    // sendPasswordReset
    username?: string,
    token?: string,
    newPassword?: string,
    responseStatus?: DTOS.ResponseStatus,
    result?: boolean,
    validToken?: boolean,
    accountActivated?: boolean
}

export const
    ASSIGN_USER_ROLE_REQUEST = "ASSIGN_USER_ROLE_REQUEST",
    ASSIGN_USER_ROLE_SUCCESS = "ASSIGN_USER_ROLE_SUCCESS",
    ASSIGN_USER_ROLE_FAILURE = "ASSIGN_USER_ROLE_FAILURE",

    UNASSIGN_USER_ROLE_REQUEST = "UNASSIGN_USER_ROLE_REQUEST",
    UNASSIGN_USER_ROLE_SUCCESS = "UNASSIGN_USER_ROLE_SUCCESS",
    UNASSIGN_USER_ROLE_FAILURE = "UNASSIGN_USER_ROLE_FAILURE",

    CURRENT_USER_REQUEST = "CURRENT_USER_REQUEST",
    CURRENT_USER_SUCCESS = "CURRENT_USER_SUCCESS",

    SEND_PASSWORD_RESET_REQUEST = "SEND_PASSWORD_RESET_TOKEN_REQUEST",
    SEND_PASSWORD_RESET_SUCCESS = "SEND_PASSWORD_RESET_TOKEN_SUCCESS",

    SEND_ACTIVATE_ACCOUNT_REQUEST = "SEND_ACTIVATE_ACCOUNT_REQUEST",
    SEND_ACTIVATE_ACCOUNT_SUCCESS = "SEND_ACTIVATE_ACCOUNT_REQUEST",

    ACTIVATE_ACCOUNT_REQUEST = "ACTIVATE_ACCOUNT_REQUEST",
    ACTIVATE_ACCOUNT_SUCCESS = "ACTIVATE_ACCOUNT_SUCCESS",

    PASSWORD_RESET_FROM_TOKEN_REQUEST =  "PASSWORD_RESET_FROM_TOKEN_REQUEST",
    PASSWORD_RESET_FROM_TOKEN_SUCCESS =  "PASSWORD_RESET_FROM_TOKEN_SUCCESS",

    CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST",
    CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS",

    CHANGE_PASSWORD_TOKEN_REQUEST = "CHANGE_PASSWORD_TOKEN_REQUEST",
    CHANGE_PASSWORD_TOKEN_SUCCESS = "CHANGE_PASSWORD_TOKEN_SUCCESS",

    IS_VALID_CHANGE_PASSWORD_TOKEN = "IS_VALID_CHANGE_PASSWORD_TOKEN",
    IS_VALID_CHANGE_PASSWORD_TOKEN_SUCCESS = "IS_VALID_CHANGE_PASSWORD_TOKEN_SUCCESS",

    REGISTER_USER_REQUEST = "REGISTER_USER_REQUEST",
    REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS",

    UPDATE_USER_PREFERENCES_REQUEST = "UPDATE_USER_PREFERENCES_REQUEST",
    UPDATE_USER_PREFERENCES_SUCCESS = "UPDATE_USER_PREFERENCES_SUCCESS",

    UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST",
    UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS",
    UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE",
    
    EMAIL_OPT_OUT_REQUEST = "EMAIL_OPT_OUT_REQUEST",
    EMAIL_OPT_OUT_SUCCESS = "EMAIL_OPT_OUT_SUCCESS",
    EMAIL_OPT_OUT_FAILURE = "EMAIL_OPT_OUT_FAILURE";

export function getCurrentUserRequest(): IUserActions {
    return {
        type: CURRENT_USER_REQUEST
    };
}

export function getCurrentUserRequestSuccess(response: DTOS.GetUserResponse): IUserActions {
    return {
        type: CURRENT_USER_SUCCESS,
        currentUser: response.user
    };
}

export function registerUser(user: IUserRegister): IRegisterUserRequestAction {
    return {
        type: REGISTER_USER_REQUEST,
        user
    };
}

export function registerUserSuccess(): IRegisterUserSuccessAction {
    return {
        type: REGISTER_USER_SUCCESS
    }
}

export function updateUser(user: IUserRegister): IUpdateUserRequestAction {
    return {
        type: UPDATE_USER_REQUEST,
        user
    };
}

export function updateUserSuccess(user: DTOS.User): IUpdateUserSuccessAction {
    return {
        type: UPDATE_USER_SUCCESS,
        user
    }
}

export function updateUserFailure(): IUpdateUserFailureAction {
    return {
        type: UPDATE_USER_FAILURE
    }
}

export function updateUserPreferencesRequest(preferences): IUpdateUserPreferencesRequestAction {
    return {
        type: UPDATE_USER_PREFERENCES_REQUEST,
        preferences: preferences
    };
}

export function updateUserPreferencesSuccess(response: DTOS.UpdateUserPreferencesResponse): IUpdateUserPreferencesSuccessAction {
    return {
        type: UPDATE_USER_PREFERENCES_SUCCESS,
    };
}

export function sendPasswordReset(username: string): IUserActions {
    return {
        type: SEND_PASSWORD_RESET_REQUEST,
        username
    };
}

export function sendPasswordResetSuccess(response: DTOS.RegisterUserResponse): IUserActions {
    return {
        type: SEND_PASSWORD_RESET_SUCCESS
        //,user: response.user
    }
}

export function sendActivateAccount(username: string): IUserActions {
    return {
        type: SEND_ACTIVATE_ACCOUNT_REQUEST,
        username
    };
}

export function sendActivateAccountSuccess(response): IUserActions {
    return {
        type: SEND_ACTIVATE_ACCOUNT_SUCCESS,
        
    }
}

export function activateAccount(token: string): IUserActions {
    return {
        type: ACTIVATE_ACCOUNT_REQUEST,
        token
    };
}

export function activateAccountSuccess(response: DTOS.ActivateUserAccountResponse): IUserActions {
    return {
        type: ACTIVATE_ACCOUNT_SUCCESS,
        accountActivated: response.accountActivated
    };
}

export function changePassword(newPassword: string): IUserActions {
    return {
        type: CHANGE_PASSWORD_REQUEST,
        newPassword
    };
}

export function changePasswordSuccess(response: DTOS.UpdateUserResponse): IChangePasswordSuccessAction {
    return {
        type: CHANGE_PASSWORD_TOKEN_SUCCESS,
        user: response.user
    }
}

export function changePasswordFromToken(token: string, newPassword: string): IUserActions {
    return {
        type: CHANGE_PASSWORD_TOKEN_REQUEST,
        token,
        newPassword
    };
}

export function changePasswordFromTokenSuccess(response: DTOS.ResetPasswordResponse): IUserActions {
    return {
        type: CHANGE_PASSWORD_TOKEN_SUCCESS,
        responseStatus: response.responseStatus,
        result: response.result

    }
}

export function isValidChangePasswordToken(token: string): IUserActions {
    return {
        type: IS_VALID_CHANGE_PASSWORD_TOKEN,
        token
    };
}

export function isValidChangePasswordTokenSuccess(response: DTOS.IsValidChangePasswordTokenResponse): IUserActions {
    return {
        type: IS_VALID_CHANGE_PASSWORD_TOKEN_SUCCESS,
        validToken: response.validToken
    }
}

export function assignUserRoleRequest(userId: number, roleId: number, plotId?: number): IAssignUserRoleRequestAction {
    return {
        type: ASSIGN_USER_ROLE_REQUEST,
        userId,
        roleId,
        plotId,
    };
}

export function assignUserRoleSuccess(response: DTOS.AssignUserRoleResponse): IAssignUserRoleSuccessAction {
    return {
        type: ASSIGN_USER_ROLE_SUCCESS,
        newUserRole: response.newUserRole,
    };
}

export function assignUserRoleFailure(): IAssignUserRoleFailureAction {
    return {
        type: ASSIGN_USER_ROLE_FAILURE
    };
}

export function unassignUserRoleRequest(userRoleId: number): IUnassignUserRoleRequestAction {
    return {
        type: UNASSIGN_USER_ROLE_REQUEST,
        userRoleId,
    };
}

export function unassignUserRoleSuccess(response: DTOS.UnassignUserRoleResponse): IUnassignUserRoleSuccessAction {
    return {
        type: UNASSIGN_USER_ROLE_SUCCESS
    };
}

export function unassignUserRoleFailure(): IUnassignUserRoleFailureAction {
    return {
        type: UNASSIGN_USER_ROLE_FAILURE
    };
}

export function emailOptOutRequest(optOutStatus: boolean): IEmailOptOutRequest {
    return {
        type: EMAIL_OPT_OUT_REQUEST,
        optOutStatus
    };
}

export function emailOptOutFailure(): IEmailOptOutFailure {
    return {
        type: EMAIL_OPT_OUT_FAILURE
    }
}
